export const alerts = {
  name: 'Alerta |||| Alertas',
  
  fields: {
    alertType: 'Tipo de Alerta',
    severity: 'Severidad',
    title: 'Título',
    message: 'Mensaje',
    hotelId: 'Instalación',
    deviceId: 'Dispositivo',
    isSent: 'Enviado',
    createdAt: 'Creado En',
    sentAt: 'Enviado En',
    context: 'Contexto',
  },
  
  status: {
    sent: 'Enviado',
    pending: 'Pendiente',
  },
  
  severity: {
    info: 'Informativo',
    warning: 'Aviso',
    critical: 'Crítico',
  },
  
  filters: {
    alertType: 'Tipo',
    severity: 'Severidad',
    dateFrom: 'Desde',
    dateTo: 'Hasta',
    all: 'Todas',
    allTypes: 'Todos los tipos',
    allSeverities: 'Todas',
    groupId: 'Grupo',
    hotelId: 'Instalación',
    allGroups: 'Todos los grupos',
    allHotels: 'Todas las instalaciones',
  },

  alertTypes: {
    DeviceOffline: 'Dispositivo sin conexión',
    HighErrorRate: 'Alta tasa de errores críticos',
    DispenserMultipleErrors: 'Errores críticos en dispensador',
  },

  actions: {
    send: 'Enviar alerta',
    sendAll: 'Enviar todas las pendientes',
  },

  messages: {
    sendSuccess: 'Alerta enviada correctamente',
    sendError: 'No se ha podido enviar la alerta',
  },
  
  tabs: {
    details: 'Detalles',
    context: 'Contexto',
  },

  show: {
    contextEmpty: 'No hay datos de contexto disponibles.',
    notSentYet: 'Aún no enviada',
    viewTechnicalData: 'Ver datos técnicos',
    sections: {
      info: 'Información de la alerta',
      location: 'Ubicación',
      timeline: 'Cronología',
      context: 'Datos de contexto',
      contextSubtitle: 'Información adicional relacionada con esta alerta',
    },
    // Etiquetas para las claves de contexto conocidas (F-B-018): las claves
    // sin mapear se humanizan a partir de la propia clave (ver AlertShow.tsx).
    contextFields: {
      device: 'Dispositivo',
      hotel: 'Instalación',
      section: 'Sección',
      reason: 'Motivo',
      timestamp: 'Fecha y hora',
    },
  },
};

export default alerts;